module.exports = __webpack_public_path__ + "img/logo.c40997f4.png";